import type { FrameStanding } from '@mantelpiece/shared';

/**
 * The words for a frame that is not `live`, in the two places they appear:
 * the chip beside its name on the frames list, and the notice at the top of
 * the frame itself. The server decides the standing; this only names it.
 */
export const STANDING_PILL: Record<Exclude<FrameStanding, 'live'>, string> = {
  grace: 'Read-only',
  dormant: 'Off',
};

/** A date as somebody would write it in a sentence: "14 March 2027". */
export const longDate = (ms: number): string =>
  new Date(ms).toLocaleDateString(undefined, { day: 'numeric', month: 'long', year: 'numeric' });

/** Whole days from now until `ms`, never below zero. */
export const daysUntil = (ms: number, now = Date.now()): number =>
  Math.max(0, Math.ceil((ms - now) / 86_400_000));
